import React from 'react';

interface ProgressIndicatorsProps {
  completed: number;
  total: number;
}

const ProgressIndicators: React.FC<ProgressIndicatorsProps> = ({ completed, total }) => {
  const indicators = [];
  for (let i = 0; i < total; i++) {
    if (i < completed) {
      indicators.push(
        <span
          key={i}
          className="valid-indicator valid"
          style={{ marginRight: '4px' }}
        />
      );
    } else {
      indicators.push(
        <span
          key={i}
          className="valid-indicator"
          style={{
            marginRight: '4px',
            backgroundColor: 'transparent',
            border: '2px solid #6c757d',
            boxShadow: 'none'
          }}
        />
      );
    }
  }
  return <>{indicators}</>;
};

export default ProgressIndicators;
